import React, { useContext, useEffect, useState, useRef } from 'react';
import { useSize } from 'ahooks';

import ListGrid from "../../../components/ListGrid";
import AppGalleryGalleryItem from "./AppGalleryGalleryItem";
import AppGalleryGalleryItemV from "./AppGalleryGalleryItemV";

import NoData from "../../../components/NoData";

import { Application, Bootstrap } from "@yulintu/freesia-bootstrap";

export default function AppGallerySection(props) {

    const context = useContext(Application.Context);
    const type = window.innerWidth < 768 ? "default" : (props.section?.props?.type || "default");
    const extendClassName = props.section?.props?.className || "alpha30";

    const refRoot = useRef();
    useSize(refRoot);

    return <>
        {
            props.title !== false ? (
                <div className='app-gallery-title'>
                    <div className='title-text'>{props.title}</div>
                </div>) : null
        }
        <ListGrid
            ref={refRoot}
            className={"list-grid-v4-h grafana white list-grid--app-gallery " + extendClassName + " itemstyle-" + type}
            style={{ justifyContent: props.section?.props?.justifyContent }}
            nodata={<NoData />}
        >
            {
                (props.apps || []).filter(c => c.enabled !== false).map?.(c => {
                    return (
                        <ListGrid.GalleryItem
                            key={c.name || c.title || c.alias}
                            canCheck={false}
                            onClick={e => props.onClick?.(c)}>
                            {
                                type === "card" ?
                                    <AppGalleryGalleryItemV  {...props} data={c}></AppGalleryGalleryItemV> :
                                    <AppGalleryGalleryItem  {...props} data={c}></AppGalleryGalleryItem>
                            }
                        </ListGrid.GalleryItem>
                    );
                })
            }
        </ ListGrid >
    </>;
}